<template>
  <v-card class="mb-4 app">
    <v-container>
      <v-row class="board">
        <v-col cols="6">
          <Container
            @click="handleDragStart('valoresDisponiveisComboBox', $event)"
            :get-child-payload="getChildPayload"
            :drop-placeholder="{ class: 'placeholder' }"
          >
            <v-autocomplete
              class="mt-5"
              v-model="selecinadoComboBox"
              :items="valoresDisponiveisComboBox"
              item-text="description"
              :label="dragname"
              return-object
              multiple
              outlined
              dense
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.description ? item.description : item }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ selecinadoComboBox.length - 1 }}) </span>
                </v-chip>
              </template>
            </v-autocomplete>
          </Container>
        </v-col>
        <v-col class="text-right" cols="5">
          <v-btn class="mt-5" color="bluePcm" dark @click="insere()">Selecionar</v-btn>
          <v-spacer />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-list dense color="background">
              <div>
                <v-subheader>{{ dragname.toUpperCase() }}</v-subheader>
                <v-list-item-group v-model="item">
                  <div>
                    <Container
                      :group-name="dragname"
                      @drag-start="handleDragStart('ValoresSelecionadosDrag', $event, ValoresSelecionadosDrag)"
                      @drop="handleDrop('ValoresSelecionadosDrag', $event)"
                      :get-child-payload="getChildPayload"
                      :drop-placeholder="{ class: 'placeholder' }"
                    >
                      <Draggable v-for="(valor, key) in ValoresSelecionadosDrag" :key="key">
                        <Card>
                          <v-list-item>
                            <v-list-item-content
                              >{{ key + 1 }} - {{ typeof valor === 'object' ? valor.description : valor }}
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="darkRed" @click="remove(key)" v-bind="attrs" v-on="on">
                                    mdi-close-circle
                                  </v-icon>
                                </template>
                                <span>Remover</span>
                              </v-tooltip>
                            </v-list-item-icon>
                          </v-list-item>
                          <v-divider class="mx-2" />
                        </Card>
                      </Draggable>
                    </Container>
                  </div>
                </v-list-item-group>
              </div>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import Card from '@/componentes/Card'

export default {
  name: 'DraggAndDrop',
  props: {
    dragname: String,
    valoresDisponiveisComboBox: Array,
    opcoesSelecionadas: Array,
  },
  components: { Container, Draggable, Card },

  data: () => ({
    item: -1,
    selecinadoComboBox: [],
    ValoresSelecionadosDrag: [],
  }),

  methods: {
    handleDragStart(lane, dragResult, value) {
      const { payload, isSource } = dragResult
      if (isSource) {
        this.draggingCard = {
          lane,
          index: payload.index,
          cardData: {
            value: value[payload.index],
          },
        }
      }
    },
    handleDrop(lane, dropResult) {
      const { removedIndex, addedIndex } = dropResult
      if (lane === this.draggingCard.lane && removedIndex === addedIndex) {
        return
      }

      if (removedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(removedIndex, 1)
      }

      if (addedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(addedIndex, 0, this.draggingCard.cardData.value)
      }
    },
    insere() {
      this.selecinadoComboBox.forEach(valueSelecionado => {
        this.ValoresSelecionadosDrag.push(valueSelecionado)
        this.valoresDisponiveisComboBox.forEach((ValueDisponivel, index) => {
          if (ValueDisponivel === this.valoresDisponiveisComboBox.find(element => element === valueSelecionado)) {
            this.valoresDisponiveisComboBox.splice(index, 1)
          }
        })
      })
      this.selecinadoComboBox = []
    },
    remove(key) {
      this.valoresDisponiveisComboBox.push(this.ValoresSelecionadosDrag[key])
      this.ValoresSelecionadosDrag.splice(key, 1)
    },
    getChildPayload(index) {
      return {
        index,
      }
    },
  },
  watch: {
    ValoresSelecionadosDrag: function(dragnovo) {
      this.$emit('dragUpdate', dragnovo)
    },
    opcoesSelecionadas(novo) {
      let array = []
      novo.forEach(opcao => {
        if (typeof opcao === 'object') {
          array.push(Object.assign({}, opcao))
        } else {
          array.push(opcao)
        }
      })
      this.ValoresSelecionadosDrag = array

      array.forEach(valueSelecionado => {
        this.valoresDisponiveisComboBox.forEach((ValueDisponivel, index) => {
          if (typeof valueSelecionado === 'object') {
            if (ValueDisponivel.value === valueSelecionado.value) {
              this.valoresDisponiveisComboBox.splice(index, 1)
            }
          } else {
            if (valueSelecionado === ValueDisponivel) {
              this.valoresDisponiveisComboBox.splice(index, 1)
            }
          }
        })
      })
    },
  },
}
</script>

<style scoped>
.board {
  display: flex;
  justify-content: flex-start;
}

.lane {
  min-width: 50px;
  min-height: 50px;
  margin: 0 0.8rem;
  padding: 0 0.7rem;
}

.placeholder {
  background: rgba(33, 33, 33, 0.08);
  border-radius: 0.4rem;
  transform: scaleY(0.65);
  transform-origin: 0% 0%;
}
.app {
  background-color: var(--v-background-base);
}
</style>
